export const ROUTES = {
    home: '/',
    presentation: '/etudedesol_presentation',
    loiElan: '/etudedesol_loielan',
    quiSommesNous: '/quisommesnous',
    espacePro: '/espacepro',
    faq: '/faq',
    planDuSite: '/plandusite',
    mentionsLegales: '/mentionslegales',
    politiqueCookies: '/politiquecookies',
    politiqueProtection: '/politiqueprotectionspersonnelles',
    devis: '/devis',
    contact: '/contact',
};

export const CONTACT = {
    email: 'contact@presentis.fr',
    tel: '04 66 62 60 09'
};